import React, { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import { NAV_LINKS } from "../data/content";
import { Logo } from "./Logo";
import { ReserveDialog } from "./ReserveDialog";

const scrollTo = (id) => {
  const el = document.getElementById(id);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNav = (id) => {
    setOpen(false);
    scrollTo(id);
  };

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? "bg-linen/95 backdrop-blur-md shadow-[0_1px_0_0_rgba(178,150,125,0.35)]" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-16">
        <div className="flex items-center justify-between h-20">
          <button data-testid="navbar-logo" onClick={() => handleNav("inicio")} className="text-left shrink-0 mr-4">
            <Logo light={!scrolled} heightClass="h-9 sm:h-10" />
          </button>

          <nav className="hidden lg:flex items-center gap-7">
            {NAV_LINKS.map((link) => (
              <button
                key={link.id}
                data-testid={`nav-link-${link.id}`}
                onClick={() => handleNav(link.id)}
                className={`text-sm font-light tracking-wide transition-colors hover:opacity-60 ${
                  scrolled ? "text-espresso" : "text-linen"
                }`}
              >
                {link.label}
              </button>
            ))}
            <ReserveDialog>
              <button
                data-testid="nav-reserve-btn"
                className="rounded-full bg-cocoa text-linen px-6 py-3 text-xs font-bold tracking-wide uppercase hover:bg-espresso transition-colors duration-300"
              >
                Apartar habitación
              </button>
            </ReserveDialog>
          </nav>

          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className={`lg:hidden ${scrolled ? "text-espresso" : "text-linen"}`}
            aria-label="Menú"
          >
            {open ? <X size={26} strokeWidth={1.5} /> : <Menu size={26} strokeWidth={1.5} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-linen border-t border-khaki/40">
          <nav className="flex flex-col px-6 py-6 gap-1">
            {NAV_LINKS.map((link) => (
              <button
                key={link.id}
                data-testid={`mobile-nav-link-${link.id}`}
                onClick={() => handleNav(link.id)}
                className="text-left py-3 text-base font-light text-espresso border-b border-khaki/30"
              >
                {link.label}
              </button>
            ))}
            <ReserveDialog>
              <button
                data-testid="mobile-nav-reserve-btn"
                className="mt-4 w-full rounded-full bg-cocoa text-linen px-6 py-4 text-sm font-bold tracking-wide uppercase"
              >
                Apartar habitación
              </button>
            </ReserveDialog>
          </nav>
        </div>
      )}
    </header>
  );
};
